import React from "react"
import PropTypes from "prop-types"
import "./treatmentDetails.scss"
import Wrapper from "components/sections/wrapper"

const TreatmentDetails = ({ treatment }) => {
  return (
    <div id="TreatmentDetails">
      <Wrapper wrapperSections={treatment.sections} />
    </div>
  )
}

TreatmentDetails.props = {
  CTA: PropTypes.string,
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
  details: PropTypes.shape({
    json: PropTypes.object,
  }),
  icon: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
  name: PropTypes.string,
  slug: PropTypes.string,
  style: PropTypes.string,
}

TreatmentDetails.propTypes = {
  treatment: PropTypes.shape(TreatmentDetails.props),
}

export default TreatmentDetails
